import { zodParse } from 'base/zod_parse';
import { z } from 'zod';
import { siteStylesSchema, WfAsset, wfVariableSchema } from './schema';
import styleGuideRaw from './style_guide_raw.json';
import { approxSiteStyleToComponent } from './style_util';

const styleGuideSchema = z.object({
  styles: siteStylesSchema,
  variables: z.array(wfVariableSchema).optional(),
  files: z.array(
    z
      .object({
        _id: z.string(),
        site: z.string(),
        fileName: z.string(),
      })
      .passthrough()
      .transform((val): WfAsset => {
        // Oh Webflow I love your inconsistency
        return { ...val, siteId: val.site };
      }),
  ),
});
// This type is a subset of the Webflow Site type
export type StyleGuide = z.infer<typeof styleGuideSchema>;

export const styleGuide = zodParse(styleGuideSchema, styleGuideRaw);

export const styleGuideStyles = styleGuide.styles.blocks.map(
  approxSiteStyleToComponent,
);
export const styleGuideStyleById = new Map(
  styleGuideStyles.map((s) => [s._id, s] as const),
);
